export const GiftIcon = ({ className }: { className?: string }) => (
  <svg
    width='19'
    height='21'
    viewBox='0 0 19 21'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <g clip-path='url(#clip0_9010_65614)'>
      <path
        d='M1.40059 16.938C1.40259 18.4168 2.29094 19.2235 3.7697 19.2215L8.16994 19.2156L8.15869 10.8768L1.39243 10.8859L1.40059 16.938ZM9.59821 19.2137L13.9984 19.2077C15.4772 19.2057 16.3633 18.3966 16.3613 16.9179L16.3532 10.8657L9.58696 10.8748L9.59821 19.2137ZM0.0115508 8.58667C0.0128255 9.53164 0.554411 9.95653 1.50659 9.95524L8.15743 9.94627L8.15079 5.01943L6.80907 5.02124C5.28703 5.02329 4.36968 4.11564 4.36821 3.01918C4.36686 2.02372 5.08742 1.43124 6.0973 1.42988C7.25868 1.42831 8.14715 2.32159 8.14908 3.75707L8.15079 5.01943L9.57906 5.0175L9.57736 3.75515C9.57542 2.31966 10.4615 1.42399 11.6228 1.42242C12.6327 1.42106 13.3549 2.01159 13.3562 3.00706C13.3577 4.10351 12.4428 5.01364 10.9208 5.01569L9.57906 5.0175L9.58571 9.94434L16.2365 9.93537C17.1959 9.93408 17.7292 9.50774 17.7279 8.56277L17.7249 6.37708C17.7237 5.4249 17.1893 5.00724 16.2299 5.00853L13.8422 5.01175C14.433 4.51323 14.7856 3.79862 14.7844 2.94021C14.7821 1.21618 13.4315 0.00614028 11.6931 0.00848545C10.373 0.0102662 9.31359 0.747473 8.86088 2.01766C8.40474 0.748699 7.34333 0.0143533 6.02326 0.0161341C4.28481 0.0184793 2.93752 1.23216 2.93985 2.95619C2.94101 3.81459 3.29543 4.52825 3.88761 5.02518L1.49994 5.0284C0.583832 5.02964 0.00731775 5.4488 0.00860224 6.40098L0.0115508 8.58667Z'
        fill='#3F3F3F'
      />
    </g>
    <defs>
      <clipPath id='clip0_9010_65614'>
        <rect
          width='17.9832'
          height='20.0174'
          fill='white'
          transform='translate(0 0.0242595) rotate(-0.0772924)'
        />
      </clipPath>
    </defs>
  </svg>
);
